<template>
  <svg :style="style" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="&#230;&#150;&#185;&#229;&#188;&#143;=&#232;&#135;&#170;&#232;&#175;&#132;, &#230;&#152;&#175;&#229;&#144;&#166;&#228;&#184;&#186;&#230;&#181;&#133;&#232;&#137;&#178;=on" clip-path="url(#clip0_4386_91501)">
<path id="Vector" d="M9.50025 5.00001C9.50025 4.86741 9.55293 4.74023 9.6467 4.64646C9.74047 4.55269 9.86764 4.50001 10.0003 4.50001H15.5003C15.6329 4.50001 15.76 4.55269 15.8538 4.64646C15.9476 4.74023 16.0003 4.86741 16.0003 5.00001C16.0003 5.13262 15.9476 5.2598 15.8538 5.35357C15.76 5.44734 15.6329 5.50001 15.5003 5.50001H10.0003C9.86764 5.50001 9.74047 5.44734 9.6467 5.35357C9.55293 5.2598 9.50025 5.13262 9.50025 5.00001ZM15.5003 7.50001H10.0003C9.86764 7.50001 9.74047 7.55269 9.6467 7.64646C9.55293 7.74023 9.50025 7.86741 9.50025 8.00001C9.50025 8.13262 9.55293 8.2598 9.6467 8.35357C9.74047 8.44734 9.86764 8.50001 10.0003 8.50001H15.5003C15.6329 8.50001 15.76 8.44734 15.8538 8.35357C15.9476 8.2598 16.0003 8.13262 16.0003 8.00001C16.0003 7.86741 15.9476 7.74023 15.8538 7.64646C15.76 7.55269 15.6329 7.50001 15.5003 7.50001ZM15.5003 10.5H11.5003C11.3676 10.5 11.2405 10.5527 11.1467 10.6465C11.0529 10.7402 11.0003 10.8674 11.0003 11C11.0003 11.1326 11.0529 11.2598 11.1467 11.3536C11.2405 11.4473 11.3676 11.5 11.5003 11.5H15.5003C15.6329 11.5 15.76 11.4473 15.8538 11.3536C15.9476 11.2598 16.0003 11.1326 16.0003 11C16.0003 10.8674 15.9476 10.7402 15.8538 10.6465C15.76 10.5527 15.6329 10.5 15.5003 10.5ZM6.83088 8.87501C7.32711 8.4928 7.69126 7.96485 7.87226 7.36521C8.05327 6.76557 8.04204 6.12432 7.84016 5.53138C7.63828 4.93844 7.25588 4.42356 6.74657 4.05895C6.23727 3.69434 5.62662 3.49829 5.00025 3.49829C4.37389 3.49829 3.76324 3.69434 3.25393 4.05895C2.74463 4.42356 2.36222 4.93844 2.16034 5.53138C1.95846 6.12432 1.94724 6.76557 2.12824 7.36521C2.30924 7.96485 2.6734 8.4928 3.16963 8.87501C1.88088 9.42064 0.865252 10.5188 0.515877 11.875C0.496795 11.9489 0.494886 12.0262 0.510299 12.101C0.525711 12.1757 0.558035 12.246 0.604792 12.3063C0.65155 12.3666 0.7115 12.4155 0.780048 12.449C0.848596 12.4826 0.923922 12.5001 1.00025 12.5H9.00025C9.07658 12.5001 9.15191 12.4826 9.22046 12.449C9.289 12.4155 9.34895 12.3666 9.39571 12.3063C9.44247 12.246 9.47479 12.1757 9.4902 12.101C9.50562 12.0262 9.50371 11.9489 9.48463 11.875C9.13525 10.5181 8.11963 9.42001 6.83088 8.87501Z" fill="#D2D5D9"/>
</g>
<defs>
<clipPath id="clip0_4386_91501">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>







</template>

<script>
export default {
  name: 'icon-self-common-black',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>